export enum PanelCheckTargetingMode {  
  Targeted = 1,
  GenPop = 2,
  TargetedFirst = 3
}

export const PanelCheckTargetingModeList = [
  { name: null },//fake element here to make the index match the enum, so we can look up by id to get the name
  { name: "Targeted", mode: PanelCheckTargetingMode.Targeted },
  { name: "GenPop", mode: PanelCheckTargetingMode.GenPop },
  { name: "TargetedFirst", mode: PanelCheckTargetingMode.TargetedFirst }
];




// WEBPACK FOOTER //
// ./src/app/enums/panel-check-targeting-mode.enum.ts